import { z } from 'zod';
import { isoDateTime, uuid } from './primitives.js';
/** PlatHunt-Konto. Existiert unabhaengig von PSN. */
export const profileSchema = z.object({
    id: uuid,
    displayName: z.string().nullable(),
    avatarUrl: z.string().url().nullable(),
    isAdmin: z.boolean(),
    isAnonymous: z.boolean(),
    theme: z.enum(['bronze', 'silver', 'gold', 'platinum']),
    locale: z.enum(['de', 'en']),
    createdAt: isoDateTime,
});
/**
 * Verknuepftes PSN-Konto. Getrennt vom PlatHunt-Account.
 * Verifizierung ueber temporaeren Bio-Code – kein dauerhaftes Bio-Monitoring.
 */
export const psnVerificationStateSchema = z.enum(['unlinked', 'pending', 'verified', 'failed']);
export const psnAccountSchema = z.object({
    id: uuid,
    userId: uuid,
    psnAccountId: z.string().min(1),
    onlineId: z.string().min(1),
    verificationState: psnVerificationStateSchema,
    verificationCode: z.string().nullable(),
    verificationCodeExpiresAt: isoDateTime.nullable(),
    verifiedAt: isoDateTime.nullable(),
    lastSyncedAt: isoDateTime.nullable(),
});
/** Earned State je Trophy und Nutzer. Kommt ausschliesslich aus dem PSN-Sync. */
export const userTrophySchema = z.object({
    userId: uuid,
    trophyId: uuid,
    earned: z.boolean(),
    earnedAt: isoDateTime.nullable(),
});
export const runSourceSchema = z.enum(['psn', 'local']);
/** Der Run eines Nutzers auf genau einem TrophySet. Niemals Set-uebergreifend. */
export const userGameRunSchema = z.object({
    id: uuid,
    userId: uuid,
    trophySetId: uuid,
    source: runSourceSchema,
    startedAt: isoDateTime,
    lastActivityAt: isoDateTime.nullable(),
    platinumEarnedAt: isoDateTime.nullable(),
});
/** Persoenliche Notiz. User-Daten, keine Redaktionsdaten. */
export const noteSchema = z.object({
    id: uuid,
    userId: uuid,
    gameId: uuid,
    trophySetId: uuid.nullable(),
    body: z.string(),
    createdAt: isoDateTime,
    updatedAt: isoDateTime,
});
/** Admin-gepflegtes Anzeige-Logo. PSN-Sync darf es nie loeschen oder ueberschreiben. */
export const customDisplayAssetScopeSchema = z.enum([
    'game',
    'trophy_set',
    'trophy_group',
    'trophy',
    'completion_section',
]);
export const customDisplayAssetSchema = z.object({
    id: uuid,
    scope: customDisplayAssetScopeSchema,
    targetId: uuid,
    logoUrl: z.string().url(),
    updatedAt: isoDateTime,
});
//# sourceMappingURL=user.js.map